export enum Loading {
	NotLoaded,
	Loading,
	Loaded
}